module.exports = __webpack_public_path__ + "img/header-img.41e29d93.png";